import { observable, computed } from 'mobx'
import constants from '@app/constants'
import { RootStore } from '@app/models/RootStore'
import { Scatterplot } from '@app/views/Scatterplot'
import { selectionForDataset } from '@app/views/utils'

const sessionName = (x: string) => `Session ${x}`

export class QualifyingPane {
  rootStore: RootStore
  @observable rect: ClientRect
  @observable pixelRatio: number

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore
  }

  resize({ rect, pixelRatio }: { rect: ClientRect; pixelRatio: number }) {
    this.rect = rect
    this.pixelRatio = pixelRatio
  }

  @computed get scatterplot() {
    return new Scatterplot({
      pixelRatio: this.pixelRatio,
      rect: this.rect,
      xDomain: this.rootStore.qualifyingNames,
      xTicks: this.rootStore.qualifyingNames,
      yDomain: this.rootStore.qualifyingDomain,
      data: this.rootStore.qualifyingTimes.map((time: any) => ({
        x: sessionName(time.session),
        y: time.clampedTime,
        color: time.color.gl,
        outline: time.outline,
        aboveDomain: time.clampedTime < time.time,
      })),
      margin: constants.MARGIN,
      message:
        this.rootStore.qualifyingTimes.length > 0 ? null : 'Data not available',
      title: 'QUALIFYING TIMES',
      ...selectionForDataset(this.rootStore, 'qualifyingTimes'),
    })
  }
}
